import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { TextField } from '@material-ui/core'


const TextFieldWithStyles = withStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    width: '90%',
  }
}))(TextField)

const inputStyles = makeStyles({
  notchedOutline: {
    borderColor: 'white',
    '&:hover': { borderColor: 'white' }
  },
  inputLabel: {
    color: 'white'
  },
  input: {
    color: 'white'
  },
})

const StdTextField = props => {
  const classes = inputStyles()
  const inputProps = {
    classes: {
      notchedOutline: classes.notchedOutline,
      input: classes.input
    },
    ...props.InputProps
  }
  const inputLabelProps = {
    classes: { root: classes.inputLabel },
    ...props.inputLabelProps
  }

  return <TextFieldWithStyles
    variant='outlined'
    InputProps={inputProps}
    InputLabelProps={inputLabelProps}
    {...props}
  />
}

export default StdTextField